import { render, staticRenderFns } from "./EndMeetingButton.vue?vue&type=template&id=5499e5a0&scoped=true&"
import script from "./EndMeetingButton.vue?vue&type=script&lang=ts&"
export * from "./EndMeetingButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5499e5a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5499e5a0')) {
      api.createRecord('5499e5a0', component.options)
    } else {
      api.reload('5499e5a0', component.options)
    }
    module.hot.accept("./EndMeetingButton.vue?vue&type=template&id=5499e5a0&scoped=true&", function () {
      api.rerender('5499e5a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/EndMeetingButton.vue"
export default component.exports